<template>
  <div ref="canvas_mu"
       class="canvas_mu">
    <canvas :id="id"
            @mousedown="onCanvasMouseDown"
            @mouseup="onCanvasMouseUp"
            @mousemove="onCanvasMouseMove"
            @mouseout="onCanvasMouseOut"
            ref="canvas"></canvas>
    <div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/common/event-bus.js'

export default {
  name: 'muCv',
  data () {
    return {
      pjImg: null,
      canvas: null,
      context: null,
      proportion: 1,
      cvX: 0,
      cvY: 0,
      screen: {
        calX: 0,
        calY: 0
      },
      selectedRect: null,
      isDragging: false,
      isMouseInCanvas: false,
      // oldPosition: {
      //   x: 0,
      //   y: 0
      // },
      moveTime: 0,
      proNum: -1,
      prcSizew: 28,
      prcSizeh: 60,
      prcStartw: 0,
      prcStarth: 0,
      w: 0,
      h: 0,
      scW: 0,
      scH: 0
    }
  },
  props: [
    'id',
    // 'w',
    // 'h',
    'rects',
    'projectRects',
    'avageArea',
    'arrowRects',
    'sectorAreas',
    'arrHelpLines',
    'screensRect',
    'arrHelpText',
    'arrArcLines',
    'arrArcHelpText',
    'arrDashLines'
  ],
  computed: {
    ...mapState([
      'muPoints', 'projectorSize', 'blendingAvaPoint', 'isProjectPosition', 'blendingParam', 'blendingEdgePoints', 'simulateTabData', 'simulateTabSele', 'blendingPositionLimit',
      'selectedLensData'
    ]),
    rectsOnCanvas: {
      get () {
        return this.rectsToCanvas()
      }
    },
    projectRectsOnCanvas: {
      get () {
        return this.projectRectsToCanvas()
      }
    },
    avageAreaOnCanvas: {
      get () {
        return this.avageAreaToCanvas()
      }
    },
    arrowRectsOnCanvas: {
      get () {
        return this.arrowRectsToCanvas()
      }
    },
    sectorAreasOnCanvas: {
      get () {
        return this.sectorAreasToCanvas()
      }
    },
    arrArcLinesOnCanvas: {
      get () {
        return this.arrArcLines
      }
    },
    arrArcHelpTextOnCanvas: {
      get () {
        return this.arrArcHelpText
      }
    },
    arrHelpLinesOnCanvas: {
      get () {
        return this.arrHelpLinesToCanvas()
      }
    },
    arrDashLinesOnCanvas: {
      get () {
        return this.arrDashLinesToCanvas()
      }
    },
    screensRectOnCanvas: {
      get () {
        return this.screensRectToCanvas()
      }
    },
    arrHelpTextOnCanvas: {
      get () {
        return this.arrHelpTextToCanvas()
      }
    }
  },
  watch: {
    // muPoints (newValue, oldValue) {
    //   console.log('watch')
    //   this.refreshData()
    //   this.drawCv()
    // }
    // blendingEdgePoints: {
    //   handler (newValue, oldValue) {
    //     this.refreshCv()
    //     // this.refreshData()
    //     this.drawCv()
    //   },
    //   deep: true
    // }
  },
  created () {
    this.pjImg = new Image()
  },
  mounted () {
    EventBus.$on('onCurveGraphChanged', (w, h) => {
      if (w) {
        this.scW = w
        this.scH = h
        this.onGraphChanged()
      }
    })
    EventBus.$on('onClearCanvas', () => {
      this.clearCanvas()
    })
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    this.refreshCv()
    if (this.id === 'curveMuViewOne') {
      this.initPjImg()
    }
    // this.refreshData()
    window.addEventListener('keydown', this.handleKeyDown, false)
    window.addEventListener('keyup', this.handelKeyUp, false)
  },
  beforeDestroy () {
    EventBus.$off('onCurveGraphChanged')
    EventBus.$off('onClearCanvas')
    window.removeEventListener('keydown', this.handleKeyDown, false)
    window.removeEventListener('keyup', this.handleKeyDown, false)
  },
  methods: {
    ...mapMutations([
      'SET_MUPOINTS'
    ]),
    /**
     * 鼠标拖动时，按照当前最小单位刻度来进行拖动，
     * m、mm 拖动1cm
     * inch 拖动0.254cm
     * feet 拖动3.048cm
     */
    getMoveDisByUnit () {
      let unit = this.graph.unit
      let moveDis = 0
      if (unit === 'T_METRE_M' || unit === 'T_MILLIMETER_MM') {
        moveDis = 1
      } else if (unit === 'T_INCH_DECIMAL') {
        moveDis = 0.254
      } else if (unit === 'T_FEET_DECIMAL') {
        moveDis = 3.048
      }
      return moveDis
    },
    initCanvasWH () {
      let offsetW = this.$refs.canvas_mu.offsetWidth
      let offsetH = this.$refs.canvas_mu.offsetHeight
      this.canvas.width = offsetW
      this.canvas.height = offsetH
    },
    getProportion () {
      let hPlus = 0
      // 平面多台ust镜头且为ceiling时
      if (this.blendingParam.screenShape === '2' && this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1 && this.blendingParam.position === '1') {
        hPlus = Math.abs(this.blendingAvaPoint[0][3].y) > Math.abs(this.blendingAvaPoint[0][0].y) ? Math.abs(this.blendingAvaPoint[0][3].y) : Math.abs(this.blendingAvaPoint[0][0].y)
      }

      this.w = this.scW
      this.h = this.scH + hPlus
      if (this.w === 0 || this.h === 0) {
        return
      }
      let calw = this.w + (this.id !== 'frontView' && this.curveDirection === '0' ? this.curveDepth : 0)
      let hLimit = this.h
      let calh = hLimit
      const wRatio = calw / this.$refs.canvas.width
      const hRatio = calh / this.$refs.canvas.height
      let maxSize = parseFloat(this.$refs.canvas.height)
      let xFactor = this.id === 'curveMuViewOne' ? 0.7 : 0.8
      if (wRatio >= hRatio) {
        maxSize = parseFloat(this.$refs.canvas.width)
      }
      maxSize = Number(maxSize) * xFactor
      if (wRatio >= hRatio) {
        this.proportion = calw * 1 / maxSize
      } else {
        this.proportion = calh * 1 / maxSize
      }
    },
    initCanvasXY () {
      if (this.id === 'curveMuView') {
        this.cvX = this.canvas.width / 2 + this.realToCanvas(this.blendingPositionLimit.w / 2)
        this.cvY = this.canvas.height / 2 + this.realToCanvas(this.blendingPositionLimit.h / 2)
        // this.cvY = this.canvas.height / 2 + this.realToCanvas(this.h) / 2
        // let dis = this.blendingParam.radius
        // if (this.h > dis) {
        //   this.cvY = this.canvas.height / 2 + this.realToCanvas(dis * 2 - this.h) / 2
        // }
      } else {
        this.cvX =
          (this.canvas.width - this.realToCanvas(this.blendingParam.screenSize.width)) / 2
        // this.cvY = (this.canvas.height - this.realToCanvas(this.blendingParam.screenSize.height)) / 2
        if (this.id === 'curveMuViewOne') {
          this.cvX = this.cvX + 20
          this.cvY = (this.canvas.height - this.realToCanvas(this.h)) / 2
        } else {
          this.cvY = (this.canvas.height - this.realToCanvas(this.blendingParam.screenSize.height)) / 2
        }
      }
      this.context.translate(this.cvX, this.cvY)
    },
    clearCanvas () {
      this.context.clearRect(
        -this.cvX,
        -this.cvY,
        this.canvas.width,
        this.canvas.height
      )
    },
    refreshCv () {
      if (this.isDragging) {
        return
      }
      this.initCanvasWH()
      this.getProportion()
      this.initCanvasXY()
    },
    async drawCv () {
      this.refreshCv()
      if (this.muPoints === null || this.muPoints.length === 0) {
        return
      }
      await this.$emit('setHelpLineAreas', this.proportion)
      // 向前一个页面发送比例字段
      this.clearCanvas()
      this.drawRoomRect()
      this.drawScreensRect()
      this.drawAvaAreas()
      this.drawProjectRect()
      this.drawSectorAreas()
      this.arrowRectsToCanvas()
      this.drawHelpLines()
      this.drawArcLines()
      this.drawArcHelpText()
      this.drawArrowheads()
      this.drawHelpText()
      this.drawProImg()
      this.drawDashLines()
    },
    drawRoomRect () {
      for (let i = 0; i < this.rectsOnCanvas.length; i++) {
        this.$draw.drawRect(
          this.context,
          this.rectsOnCanvas[i].x,
          this.rectsOnCanvas[i].y,
          this.rectsOnCanvas[i].width,
          this.rectsOnCanvas[i].height,
          '#525977',
          '#FFFFFF',
          2,
          true
        )
      }
    },
    drawProjectRect () {
      if (!this.isProjectPosition) {
        return
      }
      if (this.id === 'curveMuView') {
        let proAngle = 0
        for (let i = 0; i < this.projectRectsOnCanvas.length; i++) {
          if (this.blendingParam.screenShape === '0') {
            proAngle = this.muPoints[i].projectAngle
          } else {
            proAngle = this.muPoints[i].projectAngle + 180
          }
          this.$draw.drawMuProject(
            this.context,
            this.projectRectsOnCanvas[i].x,
            this.projectRectsOnCanvas[i].y,
            3,
            proAngle
          )
        }
      } else {
        let lineColor = '#10218B'
        for (let i = 0; i < this.projectRectsOnCanvas.length; i++) {
          if (this.blendingAvaPoint.length > 0) {
            let p = {}
            p.x = this.muPoints[i].x
            p.y = this.muPoints[i].z
            let outFlag = this.$commonJs.rayCastingByxy(p, this.blendingAvaPoint[i])
            if (outFlag === 'out') {
              lineColor = 'red'
            } else {
              lineColor = '#10218B'
            }
          }

          this.$draw.drawRect(
            this.context,
            this.projectRectsOnCanvas[i].x,
            this.projectRectsOnCanvas[i].y,
            this.projectRectsOnCanvas[i].width,
            this.projectRectsOnCanvas[i].height,
            lineColor,
            '#FFFFFF',
            2,
            false
          )
        }
      }
    },
    drawScreensRect () {
      for (let i = 0; i < this.screensRectOnCanvas.length; i++) {
        this.$draw.drawRect(
          this.context,
          this.screensRectOnCanvas[i].x,
          this.screensRectOnCanvas[i].y,
          this.screensRectOnCanvas[i].width,
          this.screensRectOnCanvas[i].height,
          '#575E79',
          this.$constant.edgeScreessColor,
          1,
          true
        )
      }
    },
    drawDashLines () {
      if (this.arrDashLinesOnCanvas.length > 0) {
        let das = [2, 2]
        let lineWidth = this.arrDashLinesOnCanvas[0].lineWidth
        let color
        if (this.id === 'curveMuView') {
          das = [5, 3]
          lineWidth = 0.5
        }
        for (var i = 0; i < this.arrDashLinesOnCanvas.length; i++) {
          color = this.$constant.dashLineColor
          if (i > this.arrDashLinesOnCanvas.length - 3 && this.id === 'curveMuView' && this.blendingParam.screenShape === '0') {
            color = '#273696'
            das = [6, 3]
            lineWidth = 1
          }
          this.$draw.drawLine(
            this.context,
            this.arrDashLinesOnCanvas[i],
            color,
            lineWidth,
            das
          )
        }
      }
    },
    drawAvaAreas () {
      for (let i = 0; i < this.avageAreaOnCanvas.length; i++) {
        for (let j = 0; j < this.avageAreaOnCanvas[i].length; j++) {
          this.$draw.drawLine(
            this.context,
            this.avageAreaOnCanvas[i][j],
            this.$constant.avageBlendColor,
            1,
            [6, 3]
          )
        }
      }
    },
    drawArrowheads () {
      if (this.arrowRectsOnCanvas) {
        for (let i = 0; i < this.arrowRectsOnCanvas.length; i++) {
          this.$draw.drawArrowhead(
            this.context,
            this.arrowRectsOnCanvas[i].x,
            this.arrowRectsOnCanvas[i].y,
            this.arrowRectsOnCanvas[i].angle,
            this.arrowRectsOnCanvas[i].color,
            5,
            10
          )
        }
      }
    },
    drawArcLines () {
      if (this.arrArcLinesOnCanvas) {
        for (let i = 0; i < this.arrArcLinesOnCanvas.length; i++) {
          this.$draw.drawArcLine(
            this.arrArcLinesOnCanvas[i].x,
            this.arrArcLinesOnCanvas[i].y,
            this.arrArcLinesOnCanvas[i].radian,
            this.arrArcLinesOnCanvas[i].color,
            this.arrArcLinesOnCanvas[i].a0,
            this.arrArcLinesOnCanvas[i].a1,
            this.arrArcLinesOnCanvas[i].lineWidth,
            this.context
          )
        }
      }
    },
    drawArcHelpText () {
      if (this.arrArcHelpTextOnCanvas) {
        for (let i = 0; i < this.arrArcHelpTextOnCanvas.length; i++) {
          this.$draw.drawTextRotate(
            this.context,
            this.arrArcHelpTextOnCanvas[i].text,
            this.arrArcHelpTextOnCanvas[i].x,
            this.arrArcHelpTextOnCanvas[i].y,
            this.$constant.helpTextColor,
            this.arrArcHelpTextOnCanvas[i].angle
          )
        }
      }
    },
    drawSectorAreas () {
      if (this.sectorAreasOnCanvas) {
        if (this.sectorAreasOnCanvas.length === 0 || this.id !== 'curveMuView') {
          return
        }
        // for (let i = 0; i < 4; i++) {
        for (let i = 0; i < this.sectorAreasOnCanvas.length; i++) {
        // let i = 4
          let ang1 = this.$commonJs.getRadianByDegrees(360 - this.$commonJs.getAngleByPoint(this.sectorAreasOnCanvas[i].p[1], this.sectorAreasOnCanvas[i].p[0]))
          let ang2 = this.$commonJs.getRadianByDegrees(360 - this.$commonJs.getAngleByPoint(this.sectorAreasOnCanvas[i].p[2], this.sectorAreasOnCanvas[i].p[0]))
          if (this.blendingParam.screenShape === '0') {
            this.$draw.drawSector(
              this.sectorAreasOnCanvas[i].p[0],
              this.sectorAreasOnCanvas[i].p[1],
              this.sectorAreasOnCanvas[i].p[2],
              this.sectorAreasOnCanvas[i].p[3],
              this.sectorAreasOnCanvas[i].radius,
              this.$constant.edgeScreessColor,
              ang1,
              ang2,
              this.context
            )
          } else {
            this.$draw.drawSectorA(
              this.sectorAreasOnCanvas[i].p[0],
              this.sectorAreasOnCanvas[i].p[1],
              this.sectorAreasOnCanvas[i].p[2],
              this.sectorAreasOnCanvas[i].p[3],
              this.sectorAreasOnCanvas[i].radius,
              this.$constant.edgeScreessColor,
              ang1,
              ang2,
              this.context
            )
          }
        }
      }
    },
    drawHelpLines () {
      for (let i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrHelpLinesOnCanvas[i],
          this.arrHelpLinesOnCanvas[i].color,
          this.arrHelpLinesOnCanvas[i].lineWidth
        )
      }
    },
    drawHelpText () {
      for (var i = 0; i < this.arrHelpTextOnCanvas.length; i++) {
        this.$draw.drawText(
          this.context,
          this.arrHelpTextOnCanvas[i].text,
          this.arrHelpTextOnCanvas[i].x,
          this.arrHelpTextOnCanvas[i].y,
          this.$constant.helpTextColor
        )
      }
    },
    /**
     * 添加投影仪的拖动图片
     */
    drawProImg () {
      if (this.id !== 'curveMuViewOne' || this.projectRectsOnCanvas.length === 0) {
        return
      }
      this.prcStartw = this.realToCanvas(this.w / 2) + 20
      this.prcStarth = this.projectRectsOnCanvas[0].y + this.projectRectsOnCanvas[0].height / 2 - this.prcSizeh / 2
      this.context.drawImage(
        this.pjImg,
        this.prcStartw,
        this.prcStarth,
        this.prcSizew,
        this.prcSizeh
      )
    },
    /**
     * 鼠标点击
     */
    onCanvasMouseDown (e) {
      if (!this.isProjectPosition) {
        return
      }
      let offsetX = e.offsetX || (e.clientX - e.target.getBoundingClientRect().left)
      let offsetY = e.offsetY || (e.clientY - e.target.getBoundingClientRect().top)
      var clickX = offsetX - this.cvX
      var clickY = offsetY - this.cvY
      if (this.id === 'curveMuViewOne') {
        this.isMouseInCanvas = true
        this.widthstart = this.prcStartw
        this.heightstart = this.prcStarth
        this.widthend = this.prcStartw + this.prcSizew
        this.heightend = this.prcStarth + this.prcSizeh
        if (clickX >= this.widthstart && clickX < this.widthend && clickY >= this.heightstart && clickY < this.heightend) {
          this.selectedRect = this.projectRectsOnCanvas[0]
          this.x1 = clickX - (this.prcStartw + this.prcSizew / 2)
          this.y1 = clickY - (this.prcStarth + this.prcSizeh / 2)
          //  使圆圈允许拖拽
          this.isDragging = true
        }
      } else {
        let pjWf = this.projectorSize.w
        let pjHf = this.projectorSize.h
        for (let i = 0; i < this.muPoints.length; i++) {
        //  查找被单击的矩形框
          var rect = this.muPoints[i]
          this.isMouseInCanvas = true
          this.widthstart = this.realToCanvas(rect.x - pjWf)
          this.widthend = this.realToCanvas(rect.x + pjWf)
          this.heightstart = this.realToCanvas(rect.z - pjHf)
          this.heightend = this.realToCanvas(rect.z + pjHf)
          //  判断这个点是否在矩形框中
          if (clickX >= this.widthstart && clickX < this.widthend && clickY >= this.heightstart && clickY < this.heightend) {
          //  清除之前选择的矩形框
            this.selectedRect = rect
            this.x1 = clickX - this.realToCanvas(rect.x - pjWf)
            this.y1 = clickY - this.realToCanvas(rect.z - pjHf)
            //  使圆圈允许拖拽
            this.isDragging = true
            this.proNum = i
            return
          }
        }
      }
    },
    /**
     * 拖拽投影仪
     */
    onCanvasMouseMove (e) {
      let cvXreal = 0
      let cvYreal = 0
      if (this.isMouseInCanvas === false) {
        return
      }
      // 判断矩形是否开始拖拽
      if (this.isDragging === true) {
        // 判断拖拽对象是否存在
        if (this.selectedRect != null) {
          let initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.simulateTabData[this.simulateTabSele].disMin)
          let w = initScreen.calX
          let h = initScreen.calY
          // 取得鼠标位置
          var x = e.offsetX || (e.clientX - e.target.getBoundingClientRect().left)
          var y = e.offsetY || (e.clientY - e.target.getBoundingClientRect().top)
          if (this.id === 'curveMuViewOne') {
            console.log('moving')
            cvYreal = this.canvasToReal(y - this.y1 - this.cvY)
            var vLens = Number((cvYreal - this.h / 2) / h * 100)
            console.log('vLens', vLens)
          } else {
            let flag = this.$commonViewJs.blendingIsReAspactRatio()
            cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.realToCanvas(this.projectorSize.w))
            cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.realToCanvas(this.projectorSize.h))
            let scW = this.muPoints[0].w
            let scH = this.muPoints[0].h
            // let cenX = scW / 2
            // let cenY = scH / 2
            if (flag) {
              if (this.selectedLensData.id.indexOf('LX') > -1 && this.blendingParam.position === '1') {
                if (cvXreal > this.blendingAvaPoint[this.proNum][0].x) {
                  cvXreal = this.blendingAvaPoint[this.proNum][0].x
                }
                if (cvXreal < this.blendingAvaPoint[this.proNum][3].x) {
                  cvXreal = this.blendingAvaPoint[this.proNum][3].x
                }
              } else {
                if (cvXreal < this.blendingAvaPoint[this.proNum][0].x) {
                  cvXreal = this.blendingAvaPoint[this.proNum][0].x
                }
                if (cvXreal > this.blendingAvaPoint[this.proNum][3].x) {
                  cvXreal = this.blendingAvaPoint[this.proNum][3].x
                }
              }

              if (cvYreal > this.blendingAvaPoint[this.proNum][1].y - 1) {
                cvYreal = this.blendingAvaPoint[this.proNum][1].y - 1
              }
              if (cvYreal < this.blendingAvaPoint[this.proNum][5].y + 1) {
                cvYreal = this.blendingAvaPoint[this.proNum][5].y + 1
              }
              var hLens2 = Number((scW / 2 + this.blendingEdgePoints[this.proNum][0].x - cvXreal) / h * 100)
              var vLens2 = Number((cvYreal - (this.blendingEdgePoints[this.proNum][0].z + scH / 2)) / w * 100)
              this.muPoints[this.proNum].vLensShift = vLens2
              this.muPoints[this.proNum].hLensShift = hLens2
            } else {
              if (cvXreal > this.blendingAvaPoint[this.proNum][1].x) {
                cvXreal = this.blendingAvaPoint[this.proNum][1].x
              }
              if (cvXreal < this.blendingAvaPoint[this.proNum][5].x) {
                cvXreal = this.blendingAvaPoint[this.proNum][5].x
              }
              if (this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1 && this.blendingParam.position === '1') {
                if (cvYreal > this.blendingAvaPoint[this.proNum][0].y + 1) {
                  cvYreal = this.blendingAvaPoint[this.proNum][0].y + 1
                }
                if (cvYreal < this.blendingAvaPoint[this.proNum][3].y - 1) {
                  cvYreal = this.blendingAvaPoint[this.proNum][3].y - 1
                }
              } else {
                if (cvYreal < this.blendingAvaPoint[this.proNum][0].y + 1) {
                  cvYreal = this.blendingAvaPoint[this.proNum][0].y + 1
                }
                if (cvYreal > this.blendingAvaPoint[this.proNum][3].y - 1) {
                  cvYreal = this.blendingAvaPoint[this.proNum][3].y - 1
                }
              }

              hLens2 = Number((scW / 2 + this.blendingEdgePoints[this.proNum][0].x - cvXreal) / w * 100)
              vLens2 = Number((cvYreal - (this.blendingEdgePoints[this.proNum][0].z + scH / 2)) / h * 100)
              this.muPoints[this.proNum].vLensShift = vLens2
              this.muPoints[this.proNum].hLensShift = hLens2
            }
            this.muPoints[this.proNum].x = cvXreal
            this.muPoints[this.proNum].z = cvYreal
            this.SET_MUPOINTS(this.muPoints)
          }
        }
      }
    },

    onCanvasMouseOut (e) {
      this.isMouseInCanvas = false
    },
    /**
     * 鼠标松开
     */
    onCanvasMouseUp () {
      this.isDragging = false
      this.isMouseInCanvas = false
    },
    onHouseInfoChanged () {
      this.context.translate(-this.cvX, -this.cvY)
      this.getProportion()
      this.initCanvasXY()
      console.log('onHouseInfoChanged')
      this.drawCv()
    },
    onGraphChanged () {
      console.log('onGraphChanged')
      this.drawCv()
    },
    initPjImg () {
      this.pjImg.onload = function () {
        // this.refreshData()
        console.log('initPjImg')
        this.drawCv()
      }.bind(this)
      this.pjImg.src = 'static/img/curve/pj_move_hover.png'
    },

    /**
     * 矩形转化
     */
    rs2c (r) {
      if (r === null || r === undefined) {
        return []
      }
      let tmp = []
      let x, y, w, h
      for (let i = 0; i < r.length; i++) {
        x = r[i].x ? this.realToCanvas(r[i].x) : 0
        y = r[i].y ? this.realToCanvas(r[i].y) : 0
        w = r[i].width ? this.realToCanvas(r[i].width) : 0
        h = r[i].height ? this.realToCanvas(r[i].height) : 0
        tmp.push(this.$draw.toRect(x, y, w, h))
      }
      return tmp
    },
    /**
     * 扇形转化
     */
    s2c (r) {
      if (r === null || r === undefined) {
        return []
      }
      let tmp = []
      for (let i = 0; i < r.length; i++) {
        let p = []
        for (let j = 0; j < r[i].p.length; j++) {
          let point = {}
          point.x = r[i].p[j].x ? this.realToCanvas(r[i].p[j].x) : 0
          point.y = r[i].p[j].y ? this.realToCanvas(r[i].p[j].y) : 0
          p.push(point)
        }
        let rad = r[i].radius ? this.realToCanvas(r[i].radius) : 0
        tmp.push(this.$draw.toSector(p, rad))
      }
      return tmp
    },
    /**
     * 区域转化
     */
    as2c (r) {
      if (r === null || r === undefined) {
        return []
      }
      let tmp = []
      let x, y, w, h
      for (let i = 0; i < r.length; i++) {
        x = r[i].x ? this.realToCanvas(r[i].x) : 0
        y = r[i].y ? this.realToCanvas(r[i].y) : 0
        w = r[i].width ? this.realToCanvas(r[i].width) : 0
        h = r[i].height ? this.realToCanvas(r[i].height) : 0
        tmp.push(this.$draw.toRect(x, y, w, h))
      }
      return tmp
    },

    l2c (l) {
      if (l === null || l === undefined) {
        return []
      }
      let tmp = []
      let x1, y1, x2, y2
      for (let i = 0; i < l.length; i++) {
        x1 = l[i].x1 ? this.realToCanvas(l[i].x1) : 0
        y1 = l[i].y1 ? this.realToCanvas(l[i].y1) : 0
        x2 = l[i].x2 ? this.realToCanvas(l[i].x2) : 0
        y2 = l[i].y2 ? this.realToCanvas(l[i].y2) : 0
        tmp.push(this.$draw.toLine(x1, y1, x2, y2, l[i].color, l[i].lineWidth))
      }
      return tmp
    },
    av2c (l) {
      if (l === null || l === undefined) {
        return []
      }
      let tmp = []
      let x1, y1, x2, y2
      for (let i = 0; i < l.length; i++) {
        let tmpl = []
        for (let j = 0; j < l[i].length; j++) {
          x1 = l[i][j].x1 ? this.realToCanvas(l[i][j].x1) : 0
          y1 = l[i][j].y1 ? this.realToCanvas(l[i][j].y1) : 0
          x2 = l[i][j].x2 ? this.realToCanvas(l[i][j].x2) : 0
          y2 = l[i][j].y2 ? this.realToCanvas(l[i][j].y2) : 0
          tmpl.push(this.$draw.toLine(x1, y1, x2, y2, l[i][j].color, l[i][j].lineWidth))
        }
        tmp.push(tmpl)
      }
      return tmp
    },
    a2c (l) {
      if (l === null || l === undefined || l.length === 0) {
        return []
      }
      let tmp = []
      let x, y
      for (let i = 0; i < l.length; i++) {
        x = l[i].x ? this.realToCanvas(l[i].x) : 0
        y = l[i].y ? this.realToCanvas(l[i].y) : 0
        tmp.push(this.$draw.toArrowHead(x, y, l[i].angle, l[i].color))
      }
      return tmp
    },

    ap2c (p) {
      if (p === null || p === undefined) {
        return []
      }
      let tmp = []
      let x, y
      for (let i = 0; i < p.length; i++) {
        let ps = []
        for (let j = 0; j < p[i].length; j++) {
          x = p[i][j].x ? this.realToCanvas(p[i][j].x) : 0
          y = p[i][j].y ? this.realToCanvas(p[i][j].y) : 0
          ps.push(this.$draw.toPoint(x, y))
        }
        tmp.push(ps)
      }
      return tmp
    },
    t2c (t) {
      if (t === null || t === undefined) {
        return []
      }
      let tmp = []
      let x, y
      for (let i = 0; i < t.length; i++) {
        x = t[i].x ? this.realToCanvas(t[i].x) : 0
        y = t[i].y ? this.realToCanvas(t[i].y) : 0
        tmp.push(this.$draw.toText(x, y, t[i].text))
      }
      return tmp
    },

    canvasToReal (data) {
      return data * this.proportion
    },
    realToCanvas (data) {
      return data / this.proportion
    },
    resizeDraw () {
      this.refreshCv()
      // this.refreshData()
      console.log('resizeDraw')
      this.drawCv()
    },
    refreshData () {
      this.rectsToCanvas()
      this.projectRectsToCanvas()
      this.avageAreaToCanvas()
      this.arrowRectsToCanvas()
      this.arrHelpLinesToCanvas()
      this.screensRectToCanvas()
    },
    rectsToCanvas () {
      return this.rs2c(this.rects)
    },
    projectRectsToCanvas () {
      return this.rs2c(this.projectRects)
    },
    avageAreaToCanvas () {
      return this.av2c(this.avageArea)
    },
    arrowRectsToCanvas () {
      return this.a2c(this.arrowRects)
    },
    sectorAreasToCanvas () {
      return this.s2c(this.sectorAreas)
    },
    arrDashLinesToCanvas () {
      return this.l2c(this.arrDashLines)
    },
    arrHelpLinesToCanvas () {
      return this.l2c(this.arrHelpLines)
    },
    screensRectToCanvas () {
      return this.rs2c(this.screensRect)
    },
    arrHelpTextToCanvas () {
      return this.t2c(this.arrHelpText)
    }
  }
}
</script>

<style scoped>

canvas {
  top: 50%;
  /* width: 500px; */
  height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/muCv.vue